import { render, staticRenderFns } from "./transaction_details.vue?vue&type=template&id=9ba70c26"
import script from "./transaction_details.vue?vue&type=script&lang=js"
export * from "./transaction_details.vue?vue&type=script&lang=js"
import style0 from "./transaction_details.vue?vue&type=style&index=0&id=9ba70c26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports